import React, { useEffect, useRef, useState } from "react";
// STYLES
import LazyImageWrapper from "./LazyImage.style";

const LazyImage = (props) => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const imgRef = useRef(null);

	// Reset the loading shimmer whenever the image source changes
	// (e.g. navigating from one game to another reuses this component)
	useEffect(() => {
		setImageLoaded(false);
	}, [props.image]);

	// Handle browser-cached images: onLoad may have already fired before this
	// render, so check whether the <img> is already complete after mount.
	useEffect(() => {
		if (imgRef.current?.complete && imgRef.current?.naturalWidth > 0) {
			setImageLoaded(true);
		}
	}, []); // eslint-disable-line

	const handleImageLoaded = () => setImageLoaded(true);

	return (
		<LazyImageWrapper imageLoaded={imageLoaded} compressedImage={props.compressedImage} {...props.wrapperProps}>
			<img
				ref={imgRef}
				alt="..."
				loading="lazy"
				src={props.image}
				className="image"
				onLoad={handleImageLoaded}
				{...props.imageProps}
			/>
		</LazyImageWrapper>
	);
};

export default LazyImage;
